export default __webpack_public_path__ + "static/media/zoom-in.613daeaf.svg";